const tipoMoneda = {
  ML: 'Moneda local',
  ME: 'Moneda extranjera'
};

export default tipoMoneda;
